.grid {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.card {
  border: 1.5px solid var(--border);
  border-radius: var(--radius);
  overflow: hidden;
  background: var(--white);
  transition: border-color 0.15s;
}

.cardOn {
  border-color: var(--blue);
}

.cardHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 16px 14px;
}

.cardInfo { flex: 1; }

.cardLabel {
  font-size: 14.5px;
  font-weight: 600;
  color: var(--ink);
  margin-bottom: 3px;
}

.cardHint {
  font-size: 13px;
  color: var(--muted);
  line-height: 1.45;
}

/* Mini toggle — matches Toggle.module.css */
.toggle {
  position: relative;
  width: 46px;
  height: 26px;
  flex-shrink: 0;
  cursor: pointer;
  margin-top: 1px;
}

.toggle input {
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
}

.track {
  position: absolute;
  inset: 0;
  background: #bdc1c6;
  border-radius: 26px;
  transition: background 0.2s;
}

.toggle input:checked + .track { background: var(--blue); }

.thumb {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: white;
  box-shadow: var(--shadow-sm);
  transition: transform 0.2s;
  pointer-events: none;
}

.toggle input:checked ~ .thumb { transform: translateX(20px); }

.previewImg {
  border-top: 1px solid var(--border);
  background: var(--white);
  padding: 16px;
}

.previewImg img {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 6px;
  box-shadow: var(--shadow);
}
